<template>
    <div class="result_row">
        <div class="row_title">
            {{ $t('search.newsflashes') }}
        </div>
        <div class="links_articles flex">
            <div
                v-for="(article, index) in newsflashes?.rows"
                :key="index"
                class="link_row"
            >
                <nuxt-link :to="$getArticleLink(article)" class="link">
                    <div class="title">
                        {{ article.name }}
                    </div>
                </nuxt-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        newsflashes: {
            type: Object,
            required: true
        }
    }
};
</script>
